import { render, staticRenderFns } from "./editInject.vue?vue&type=template&id=04701a14&scoped=true&"
import script from "./editInject.vue?vue&type=script&lang=js&"
export * from "./editInject.vue?vue&type=script&lang=js&"
import style0 from "./editInject.vue?vue&type=style&index=0&id=04701a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04701a14",
  null
  
)

export default component.exports